module.exports = __webpack_public_path__ + "static/media/56_tn.9294845a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/56_tn.jpg
// module id = 544
// module chunks = 0